export enum PeerReportType {
	SIMPLE_PEER_REPORT = 'SIMPLE_PEER_REPORT',
	PARENT_PEER_REPORT = 'PARENT_PEER_REPORT',
	INHERITED_REPORT = 'INHERITED_REPORT'
}
